import React from 'react'
import {connect} from 'react-redux'
import styles from '../auth/auth.scss'
import {setAppModule, changeAuthState} from 'state/actions'
import i18n from 'lib/i18n'
import c from 'state/constants'
import reactStringReplace from 'react-string-replace'
import Grail from 'elements/Grail'

const _ = i18n('privacy')

@connect(state => ({
    authState: state.auth.authState,
	isPhone: state.responsive.isPhone
}))
export default class Privacy extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired
	}

    onClickBack(e) {
        const {dispatch} = this.props

        // dispatch(changeAuthState(""))
        // to be sure be dropped to the start page
        dispatch(setAppModule(c.LOGIN))
        return
    }

    render() {
        const {isPhone} = this.props
        const regExForClientRecipientPrivacy = /(https?:\/\/\S+)/g
        const replacementFunction = (match, i, offset) => <a href={match} key={match + i}>{match}</a>
        const descriptionNL = reactStringReplace(_("privacyLinksInNl"), regExForClientRecipientPrivacy, replacementFunction)
        const descriptionFR = reactStringReplace(_("privacyLinksInFr"), regExForClientRecipientPrivacy, replacementFunction)

        return (
            <Grail
				noScroll
				content={
					<div className={`${styles.authFormsOverlay} ${isPhone ? styles.mobile : ''}`}>
						<div className={styles.authWrappNew}>
                            <div className={styles.authFormsContainerBig}>
                                <div className={styles.form}>
                                    <div className={styles.formGroup}>
                                        <h2>{_("titleOfPrivacy")}</h2>
                                    </div>
                                    <div className={styles.privacyContainer}>
                                        <div className={styles.info}>
                                            {descriptionNL}<br/>
                                            {descriptionFR}
                                        </div>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <a className={styles.backLink} onClick={(e) => this.onClickBack(e)}>{_('back')}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                 }
            />

        )
    }
}



// WEBPACK FOOTER //
// ./components/privacy/privacy.jsx